// extracted by mini-css-extract-plugin
export var clickable = "clickable-module--clickable--3kJrV";
export var primary = "clickable-module--primary--_cPz-";
export var decorated = "clickable-module--decorated--3-yjc";
export var secondary = "clickable-module--secondary--1C60y";
export var ghost = "clickable-module--ghost--23_YF";
export var clickToAction = "clickable-module--clickToAction--3lKmL";
export var title = "clickable-module--title--2kmBr";
export var subtitle = "clickable-module--subtitle--lGmO2";